import { h, Component } from "preact";

const YouTubeVideo = ({ code, width, style = {} }) => {
  return (
    <iframe
      width={width}
      height={width}
      className={style}
      src={`https://www.youtube.com/embed/${code}`}
      frameborder="0"
      allow="encrypted-media"
      allowfullscreen
    />
  );
};
export default YouTubeVideo;



// WEBPACK FOOTER //
// ./components/YouTubeVideo.js